import React, { useEffect, useState } from "react";
import PersonList from "./components/PersonList";
import axios from "axios";
import MessageList from "./components/MessageList";
// import { Spinner } from "react-bootstrap";
import CreateOrderComponent from "./components/CreateOrderComponent";
import { FACEBOOK_API_VERSION } from "../../constants";

const pageAccessToken = "";

const MessengerList = () => {
  const [fbUsers, setFbUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingMessages, setIsLoadingMessages] = useState(false);
  const [isCreatedOrder, setIsCreatedOrder] = useState(false);
  const [selectedFbUser, setSelectedFbUser] = useState(null);
  const [fbUserMessages, setFbUserMessages] = useState([]);
  const [selectedPage, setSelectedPage] = useState(null);

  useEffect(() => {
    fetchFbUsers();
  }, []);

  useEffect(() => {
    if (selectedPage?.id) {
      fetchFbUsers();
    }
  }, [selectedPage?.id]);

  useEffect(() => {
    if (selectedFbUser) {
      fetchFbUserMessages(selectedFbUser);
    }
  }, [selectedFbUser]);

  const fetchFbUserMessages = async (_selectedFbUser) => {
    setIsLoadingMessages(true);
    try {
      const response = await axios.get(`https://graph.facebook.com/${FACEBOOK_API_VERSION}/${_selectedFbUser?.id}?fields=message_count,id,name,messages{id,message,from}&limit=1&access_token=${pageAccessToken}`);
      setFbUserMessages(response.data.messages.data.reverse());
    } catch (error) {
      setFbUserMessages([]);
      console.error('Error fetching messages:', error);
    } finally {
      setIsLoadingMessages(false);
    }
  };

  const fetchFbUsers = async () => {
    const pageId = selectedPage?.id || '110377001745895';
    try {
      setIsLoading(true);
      const response = await axios.get(`https://graph.facebook.com/${FACEBOOK_API_VERSION}/${pageId}/conversations?fields=id,senders,messages.limit(1){message}&limit=50&access_token=${pageAccessToken}`);
      const conversations = response.data.data;
      const usersWithPictures = await Promise.all(conversations.map(async (conversation) => {
        const participantId = conversation.senders.data[0].id;
        const pictureUrl = await getFacebookProfilePictureUrl(participantId);
        return { ...conversation, picture: pictureUrl };
      }));
      setFbUsers(usersWithPictures);
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const getFacebookProfilePictureUrl = async (userId) => {
    try {
      const response = await axios.get(`https://graph.facebook.com/${userId}?fields=picture&type=large&access_token=${pageAccessToken}`);
      return response.data.picture.data.url;
    } catch (error) {
      console.error('Error fetching profile picture:', error);
      return null;
    }
  };

  return (
    <div style={{ display: 'flex', width: '100%' }}>
      <div style={{ width: '25%', background: '#f1f1f1', padding: 10, minHeight: '92vh' }}>
        <PersonList
          fbUsers={fbUsers}
          isLoading={isLoading}
          setSelectedFbUser={setSelectedFbUser}
          selectedFbUser={selectedFbUser}
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
        />
      </div>
      <div style={{ width: !isCreatedOrder ? '100%' : '60%' }}>
        <MessageList
          fbUserMessages={fbUserMessages}
          selectedFbUser={selectedFbUser}
          isLoadingMessages={isLoadingMessages}
          setIsCreatedOrder={setIsCreatedOrder}
          isCreatedOrder={isCreatedOrder}
          pageAccessToken={pageAccessToken}
          fetchFbUserMessages={fetchFbUserMessages}
        />
      </div>
      {isCreatedOrder && (
        <CreateOrderComponent
          setIsCreatedOrder={setIsCreatedOrder}
          selectedFbUser={selectedFbUser}
          setSelectedFbUser={setSelectedFbUser}
          selectedPage={selectedPage}
        />
      )}
    </div>
  );
};

export default MessengerList;
